import { registerLocaleData } from '@angular/common'
import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import localeDe from '@angular/common/locales/de'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from '@awork/environments/environment'
import { MobileUpdateService } from './app/shared/services/mobile-update-service/mobile-update.service'

registerLocaleData(localeDe, 'de')

if (environment !== 'local') {
  enableProdMode()
}

bootstrapApplication(AppComponent, appConfig)
  .then(application => {
    void application.injector
      .get(MobileUpdateService)
      .notifyAppReady()
      .catch(err => console.error('Could not confirm mobile app startup', err))
  })
  .catch(err => console.error(err))
